import { createGlobalStyle } from 'styled-components';
import '@/shared/assets/fonts/satoshi.css';

export const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;

        /* Firefox */
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.palette.divider} transparent;

        /* WebKit (Chrome, Safari, Edge) */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.palette.divider};
            border-radius: 4px;
        }
    }

    body {
        margin: 0;
        padding: 0;
        font-family: "Satoshi", "Roboto", "Helvetica", "Arial", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: ${({ theme }) => theme.palette.background.default};
        color: ${({ theme }) => theme.palette.text.primary};
    }

    html {
        scroll-behavior: smooth;
    }

    #root {
        min-height: 100vh;
    }
`;
